import { KeyboardArrowDown } from '@mui/icons-material';
import {
  FormControl,
  Select,
  SelectProps,
  Skeleton,
  Typography,
} from '@mui/material';

type TableFilterProps<T> = SelectProps<T> & {
  isLoading?: boolean;
};

export function TableFilter<T>({
  children,
  label,
  id,
  isLoading,
  ...props
}: TableFilterProps<T>) {
  return (
    <div className="flex gap-1 items-center">
      <label htmlFor={id} className="text-xs font-semibold shrink-0">
        {label}:
      </label>
      <FormControl size="small" variant="outlined">
        {isLoading ? (
          <Typography variant="body2" className="text-gray-500">
            <Skeleton
              variant="rounded"
              width={64}
              height={16}
              className="rounded-md"
            />
          </Typography>
        ) : (
          <Select<T>
            id={id}
            slotProps={{
              root: {
                className: `capitalize ${props.slotProps?.root?.className} font-medium`,
              },
              input: {
                className: 'text-sm',
              },
            }}
            displayEmpty
            renderValue={selected => {
              return String(selected || 'All');
            }}
            IconComponent={KeyboardArrowDown}
            sx={{
              '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
              },
            }}
            {...props}
          >
            {children}
          </Select>
        )}
      </FormControl>
    </div>
  );
}
